import { ConnectPermission } from '../permissions';
import { JobTitle } from '../v4';

export type UserUpdateEvent = {
  account: string;
  email: string | null;
  externalId: string;
  firstName: string;
  id?: string;
  info?: string;
  jobTitle: JobTitle;
  lastName: string;
  phoneNumber?: string;
  rank?: string;
  roles: string[];
  username: string;
};

export type UserStatusUpdateEvent = {
  externalId: string;
  userStatus: UserStatus;
};

export type UserPermissionUpdateEvent = {
  externalId: string;
  permissions: ConnectPermission[];
};

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
}
